<template>
  <section id="kontakt" class="bg-white py-20 sm:py-28">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-2xl text-center">
        <span class="section-label">Kontakt</span>
        <h2 class="section-title">Zapytaj o wycenę realizacji</h2>
        <p class="mt-5 text-base leading-relaxed text-graphite-600">
          Opisz swoje zlecenie, a przygotujemy dla Ciebie indywidualną wycenę. Odpowiadamy
          na zapytania w ciągu 1-2 dni roboczych.
        </p>
      </div>

      <div class="mt-16 grid grid-cols-1 gap-12 lg:grid-cols-5">
        <div class="lg:col-span-2">
          <div class="space-y-5">
            <div class="flex items-start gap-4 border-2 border-graphite-900 p-5">
              <div class="flex h-10 w-10 shrink-0 items-center justify-center border-2 border-brand-600 text-brand-600">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"/></svg>
              </div>
              <div>
                <h3 class="text-sm font-bold text-graphite-900">Telefon</h3>
                <a href="tel:+48616682142" class="mt-1 block text-sm font-medium text-graphite-600 hover:text-brand-600">+48 000 000 000</a>
              </div>
            </div>

            <div class="flex items-start gap-4 border-2 border-graphite-900 p-5">
              <div class="flex h-10 w-10 shrink-0 items-center justify-center border-2 border-brand-600 text-brand-600">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"/></svg>
              </div>
              <div>
                <h3 class="text-sm font-bold text-graphite-900">E-mail</h3>
                <a href="mailto:biuro@monteco.pl" class="mt-1 block text-sm font-medium text-graphite-600 hover:text-brand-600">biuro@monteco.pl</a>
              </div>
            </div>

            <div class="flex items-start gap-4 border-2 border-graphite-900 p-5">
              <div class="flex h-10 w-10 shrink-0 items-center justify-center border-2 border-brand-600 text-brand-600">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"/></svg>
              </div>
              <div>
                <h3 class="text-sm font-bold text-graphite-900">Adres</h3>
                <p class="mt-1 text-sm font-medium text-graphite-600">Główna 1, 62-090 Krzyszkowo</p>
              </div>
            </div>

            <div class="border-2 border-graphite-900 p-5">
              <h3 class="text-sm font-bold text-graphite-900">Dane rejestrowe</h3>
              <p class="mt-1 text-sm font-medium text-graphite-600">MONTECO JERZYŃSKI Sp.j.</p>
              <dl class="mt-3 space-y-1 text-sm text-graphite-600">
                <div class="flex gap-2">
                  <dt class="w-16 shrink-0 font-bold uppercase tracking-wider text-graphite-400">NIP</dt>
                  <dd class="font-medium">781-193-95-71</dd>
                </div>
                <div class="flex gap-2">
                  <dt class="w-16 shrink-0 font-bold uppercase tracking-wider text-graphite-400">REGON</dt>
                  <dd class="font-medium">366273125</dd>
                </div>
                <div class="flex gap-2">
                  <dt class="w-16 shrink-0 font-bold uppercase tracking-wider text-graphite-400">KRS</dt>
                  <dd class="font-medium">0000657117</dd>
                </div>
              </dl>
            </div>
          </div>
        </div>

        <div class="lg:col-span-3">
          <form class="border-2 border-graphite-200 bg-graphite-50 p-6 sm:p-8" @submit.prevent="handleSubmit">
            <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
              <div>
                <label class="form-label" for="name">Imię i nazwisko *</label>
                <input id="name" v-model.trim="form.name" type="text" class="form-input" required />
              </div>
              <div>
                <label class="form-label" for="company">Firma</label>
                <input id="company" v-model.trim="form.company" type="text" class="form-input" />
              </div>
              <div>
                <label class="form-label" for="email">E-mail *</label>
                <input id="email" v-model.trim="form.email" type="email" class="form-input" required />
              </div>
              <div>
                <label class="form-label" for="phone">Telefon *</label>
                <input id="phone" v-model.trim="form.phone" type="tel" class="form-input" required />
              </div>
              <div class="sm:col-span-2">
                <label class="form-label" for="service">Interesująca usługa</label>
                <select id="service" v-model="form.service" class="form-input">
                  <option value="">Wybierz usługę (opcjonalnie)</option>
                  <option v-for="s in serviceOptions" :key="s" :value="s">{{ s }}</option>
                </select>
              </div>
              <div class="sm:col-span-2">
                <label class="form-label" for="message">Opis zlecenia *</label>
                <textarea id="message" v-model.trim="form.message" rows="5" class="form-input" required></textarea>
              </div>
            </div>

            <label class="mt-5 flex items-start gap-2.5 text-xs leading-relaxed text-graphite-500">
              <input v-model="form.consent" type="checkbox" required class="mt-0.5 h-4 w-4 border-graphite-400 text-brand-600 focus:ring-brand-500" />
              Wyrażam zgodę na przetwarzanie moich danych osobowych w celu obsługi zapytania ofertowego. *
            </label>

            <button type="submit" :disabled="submitting" class="btn-primary mt-6 w-full disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto">
              {{ submitting ? 'Wysyłanie...' : 'Wyślij zapytanie' }}
            </button>

            <p v-if="submitted" class="mt-4 border-2 border-brand-600 bg-white px-4 py-3 text-sm font-medium text-brand-800">
              Dziękujemy! Wiadomość została wysłana — odpowiemy najszybciej jak to możliwe.
            </p>
            <p v-if="submitError" class="mt-4 border-2 border-red-600 bg-white px-4 py-3 text-sm font-medium text-red-800">
              Nie udało się wysłać wiadomości przez formularz. Napisz bezpośrednio na
              <a href="mailto:biuro@monteco.pl" class="underline">biuro@monteco.pl</a> lub zadzwoń pod
              <a href="tel:+48616682142" class="underline">+48 000 000 000</a>.
            </p>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const API_BASE = process.env.VUE_APP_API_ADRESS;

export default {
  name: 'ContactSection',
  data() {
    return {
      submitting: false,
      submitted: false,
      submitError: false,
      serviceOptions: [
        'Projektowanie CAD',
        'Ślusarstwo',
        'Wypalanie akcesoriów (laser/plazma)',
        'Cięcie blach',
        'Gięcie blach',
        'Spawanie',
        'Malowanie natryskowe',
        'Cynkowanie'
      ],
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        service: '',
        message: '',
        consent: false
      }
    };
  },
  methods: {
    async handleSubmit() {
      this.submitting = true;
      this.submitted = false;
      this.submitError = false;

      try {
        const response = await fetch(`${API_BASE}/api/contact-messages`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            name: this.form.name,
            email: this.form.email,
            number: this.form.phone,
            company: this.form.company || null,
            topic: this.form.service ? `Zapytanie ofertowe: ${this.form.service}` : 'Zapytanie ofertowe (Monteco)',
            category: this.form.service || 'Ogólne zapytanie',
            source: 'monteco',
            message: this.form.message
          })
        });

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        this.submitted = true;
        this.form = {
          name: '',
          company: '',
          email: '',
          phone: '',
          service: '',
          message: '',
          consent: false
        };
      } catch (error) {
        console.error('Nie udało się wysłać zapytania:', error);
        this.submitError = true;
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>
